import { DepartmentType, loggedInUserQuery } from '@shared/services/gql.service';
import { Maybe } from '@shared/utils/utils';

export class LoggedInUser {
  private all_departments: Array<DepartmentType | null> | null | undefined;
  private department: Array<DepartmentType | null> | null | undefined;
  private is_sys_admin = false;
  private organization_id: Maybe<string> = '';
  private permissions: Array<string> = [];
  private roles: Array<string> = [];
  private sub = '';
  private title: Maybe<string> = '';
  private trial_id = '';

  constructor(fromQuery: null | Omit<loggedInUserQuery, '__typename'>) {
    if (fromQuery && fromQuery.sub) {
      this.sub = fromQuery.sub;
      this.is_sys_admin = fromQuery.is_sys_admin;
      this.trial_id = fromQuery.trial_id ?? '';
      this.department = fromQuery.department;
      this.all_departments = fromQuery.all_departments;
      this.title = fromQuery.title;
      this.organization_id = fromQuery.organization_id;
      this.permissionsAndRolesUpperCase(fromQuery);
    }

    Object.freeze(this.roles);
    Object.freeze(this.permissions);
  }

  getAllDepartments() {
    return this.all_departments;
  }

  getDepartment() {
    return this.department;
  }

  getOrganizationId() {
    return this.organization_id;
  }

  getPermissions() {
    return this.permissions;
  }

  getRoles() {
    return this.roles;
  }

  getSub() {
    return this.sub;
  }

  getTitle() {
    return this.title;
  }

  getTrialId() {
    return this.trial_id;
  }

  hasPermission(...permissionsToCheck: string[]): boolean {
    if (!Array.isArray(permissionsToCheck)) return false;

    for (const p of permissionsToCheck) {
      if (typeof p === 'string' && p) {
        if (this.permissions.indexOf(p) >= 0) {
          return true;
        }
      }
    }

    return false;
  }

  hasRole(...rolesToCheck: string[]): boolean {
    if (!Array.isArray(rolesToCheck)) return false;

    for (const r of rolesToCheck) {
      if (typeof r === 'string' && r) {
        if (this.roles.indexOf(r) >= 0) {
          return true;
        }
      }
    }

    return false;
  }

  IsSysAdmin() {
    return this.is_sys_admin;
  }

  private permissionsAndRolesUpperCase(fromQuery: Omit<loggedInUserQuery, '__typename'>) {
    if (Array.isArray(fromQuery.roles)) {
      fromQuery.roles.forEach((r) => {
        if (typeof r === 'string' && r) {
          this.roles.push(r.toUpperCase());
        }
      });
    }

    if (Array.isArray(fromQuery.permissions)) {
      fromQuery.permissions.forEach((p) => {
        if (typeof p === 'string' && p) {
          this.permissions.push(p.toUpperCase());
        }
      });
    }
  }
}
